import { render, staticRenderFns } from "./PasoTres.vue?vue&type=template&id=6e356881"
import script from "./PasoTres.vue?vue&type=script&lang=js"
export * from "./PasoTres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports